import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { reportError } from '../../lib/error-reporter';
import { getCurrentPurchase } from '../../selectors/purchase-selector';

const HEARTBEAT_FREQUENCY = 60000;

export default function (ComposedComponent) {
  class SessionHeartbeat extends PureComponent {
    componentDidMount() {
      const { purchase: { sessionHeartbeatUrl } } = this.props;
      if (!sessionHeartbeatUrl) return null;
      this.heartbeater = setInterval(this.sendHeartbeat, HEARTBEAT_FREQUENCY);
    }

    componentWillUnmount() {
      if (!this.heartbeater) return null;
      clearInterval(this.heartbeater);
    }

    sendHeartbeat = () => {
      const { purchase: { sessionHeartbeatUrl } } = this.props;
      fetch(sessionHeartbeatUrl, {
        method: 'POST',
        credentials: 'include',
      })
      .catch((error) => {
        reportError({ error, component: 'Heartbeat', params: {}});
      });
    };

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state) => ({ purchase: getCurrentPurchase(state) });
  return connect(mapStateToProps)(SessionHeartbeat);
}



// WEBPACK FOOTER //
// ./src/components/hoc/session-heartbeat.js